import script from "./SearchFilterEntityChoices.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchFilterEntityChoices.vue?vue&type=script&setup=true&lang=ts"

import "./SearchFilterEntityChoices.vue?vue&type=style&index=0&id=18c970a3&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18c970a3"]])

export default __exports__